import { BsPlayFill, BsPauseFill } from 'react-icons/bs';

interface PlayPauseButtonProps {
  onClick: () => void;
  isPlaying: boolean
}

const PlayPauseButton = ({onClick, isPlaying}: PlayPauseButtonProps) => {
  return (
    <button
      onPointerDown={(e) => { e.preventDefault(); onClick(); }}
      className="w-20 h-20 rounded-full border border-zinc-700 hover:border-zinc-400 flex items-center justify-center transition-colors duration-200 text-zinc-400 hover:text-white"
    >
      {isPlaying
        ? <BsPauseFill size={28} />
        : <BsPlayFill size={28} className="ml-1" />
      }
    </button>
  );
}

export default PlayPauseButton;
